(function () {
  "use strict";

  var PRODUCT_HANDLES = {
    record: "record-of-title-current-with-diagram",
    instruments: "instruments-document",
    guaranteed: "record-of-title-guaranteed-search",
    package: "pre-purchase-diligence-package",
    historical: "record-of-title-historical",
    legal: "legal-owner-search",
    survey: "cadastral-survey-plan-title-sheet",
    expert: "expert-advice"
  };

  var PRODUCT_VARIANTS = {
    record: "42338771468427",
    guaranteed: "42344182284427",
    historical: "42344192278667",
    instruments: "42382781186187",
    package: "42344216461451",
    legal: "42344214659211",
    survey: "42344210792587",
    expert: "42344219377803"
  };

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function getInputAddress() {
    var input = document.getElementById("addressInput");
    return input ? input.value.trim() : "";
  }

  function getPanelAddress() {
    var el = document.getElementById("propAddress");
    var text = el ? el.textContent.trim() : "";
    return text && text !== "Loading..." && text !== "Unknown" && text !== "-" && text !== "—" ? text : "";
  }

  function getTitleRef() {
    var el = document.getElementById("titleRefValue");
    var text = el ? el.textContent.trim() : "";
    if (!text || text === "..." || text === "N/A" || text === "-" || text === "—") return "";
    return text;
  }

  function getLegalDescription() {
    var el = document.getElementById("propLegal");
    var text = el ? el.textContent.trim() : "";
    return text.replace(/^Legal:\s*/i, "");
  }

  function getManualLookupDetails() {
    var el = document.getElementById("manualLookupDetails");
    var text = el ? el.value.trim() : "";
    return text.slice(0, 220);
  }

  function storageGet(key) {
    try {
      return window.localStorage ? window.localStorage.getItem(key) : "";
    } catch (error) {
      return "";
    }
  }

  function storageSet(key, value) {
    try {
      if (window.localStorage && value) window.localStorage.setItem(key, value);
    } catch (error) {}
  }

  function bestAddress() {
    return getPanelAddress() || getInputAddress() || storageGet("certnz_address") || storageGet("selectedAddress") || "";
  }

  function remember() {
    var address = bestAddress();
    var titleRef = getTitleRef() || storageGet("certnz_titleRef") || storageGet("selectedTitleRef") || "";
    var legal = getLegalDescription();
    var manualLookup = getManualLookupDetails() || storageGet("certnz_manualLookup") || "";

    try {
      if (address) {
        storageSet("certnz_address", address);
        storageSet("selectedAddress", address);
      }
      if (titleRef) {
        storageSet("certnz_titleRef", titleRef);
        storageSet("selectedTitleRef", titleRef);
      }
      if (legal) storageSet("certnz_legalDesc", legal);
      if (manualLookup) storageSet("certnz_manualLookup", manualLookup);
      storageSet("certnz_timestamp", Date.now().toString());
    } catch (error) {}

    return { address: address, titleRef: titleRef, legal: legal, manualLookup: manualLookup };
  }

  function appendDetailsToUrl(url) {
    var details = remember();
    var params = new URLSearchParams();
    if (details.address) params.set("address", details.address);
    if (details.titleRef) params.set("titleRef", details.titleRef);
    if (details.legal) params.set("legalDescription", details.legal);
    if (details.manualLookup) params.set("manualLookup", details.manualLookup);
    var query = params.toString();
    if (!query) return url;
    return url + (url.indexOf("?") >= 0 ? "&" : "?") + query;
  }

  function addToCart(productKey) {
    var details = remember();
    var variantId = PRODUCT_VARIANTS[productKey];
    if (!variantId) return false;

    if (!details.address && !details.titleRef && !details.manualLookup) {
      var input = document.getElementById("addressInput");
      if (input) {
        input.focus();
        input.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return true;
    }

    var properties = {};
    if (details.address) properties["Property Address"] = details.address;
    if (details.titleRef) properties["Title Reference"] = details.titleRef;
    if (details.legal) properties["Legal Description"] = details.legal;
    if (details.manualLookup) properties["Address Search Notes"] = details.manualLookup;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Cart add failed");
        return response.json();
      })
      .then(function () {
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            attributes: {
              "Property Address": details.address || "",
              "Title Reference": details.titleRef || "",
              "Legal Description": details.legal || "",
              "Address Search Notes": details.manualLookup || ""
            }
          })
        });
      })
      .then(function () {
        window.location.href = "/cart";
      })
      .catch(function () {
        var fallback = "/cart/add?id=" + encodeURIComponent(variantId) + "&quantity=1";
        if (details.address) fallback += "&properties[Property Address]=" + encodeURIComponent(details.address);
        if (details.titleRef) fallback += "&properties[Title Reference]=" + encodeURIComponent(details.titleRef);
        if (details.legal) fallback += "&properties[Legal Description]=" + encodeURIComponent(details.legal);
        if (details.manualLookup) fallback += "&properties[Address Search Notes]=" + encodeURIComponent(details.manualLookup);
        window.location.href = fallback;
      });

    return true;
  }

  function patchProductButtons() {
    document.querySelectorAll(".panel-card-buy").forEach(function (button) {
      if (button.__certnzAddressFixed) return;
      button.__certnzAddressFixed = true;
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addToCart(button.getAttribute("data-product"));
      }, true);
    });

    document.querySelectorAll(".panel-card-details-link").forEach(function (link) {
      if (link.__certnzAddressFixed) return;
      link.__certnzAddressFixed = true;
      link.addEventListener("click", function () {
        remember();
        link.href = appendDetailsToUrl(link.getAttribute("href") || link.href);
      }, true);
    });
  }

  function patchAddressPersistence() {
    var input = document.getElementById("addressInput");
    if (input && !input.__certnzAddressPersistFixed) {
      input.__certnzAddressPersistFixed = true;
      input.addEventListener("input", function () {
        try {
          var value = input.value.trim();
          if (value) {
            storageSet("certnz_address", value);
            storageSet("selectedAddress", value);
            storageSet("certnz_timestamp", Date.now().toString());
          }
        } catch (error) {}
      });
    }

    var manualLookup = document.getElementById("manualLookupDetails");
    var manualLookupCount = document.getElementById("manualLookupCount");
    var manualLookupWrap = document.getElementById("manualLookup");
    var manualLookupToggle = document.getElementById("manualLookupToggle");
    if (manualLookupWrap && manualLookupToggle && !manualLookupToggle.__certnzManualToggleFixed) {
      manualLookupToggle.__certnzManualToggleFixed = true;
      manualLookupToggle.addEventListener("click", function () {
        var isOpen = manualLookupWrap.classList.toggle("is-open");
        manualLookupToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
        if (isOpen && manualLookup) manualLookup.focus();
      });
    }
    if (manualLookup && !manualLookup.__certnzManualPersistFixed) {
      manualLookup.__certnzManualPersistFixed = true;
      var savedManualLookup = storageGet("certnz_manualLookup");
      if (savedManualLookup && !manualLookup.value) {
        manualLookup.value = savedManualLookup.slice(0, 220);
        if (manualLookupWrap) manualLookupWrap.classList.add("is-open");
        if (manualLookupToggle) manualLookupToggle.setAttribute("aria-expanded", "true");
      }
      function updateManualLookup() {
        var value = manualLookup.value.slice(0, 220);
        if (manualLookup.value !== value) manualLookup.value = value;
        if (manualLookupCount) manualLookupCount.textContent = String(value.length);
        if (value) storageSet("certnz_manualLookup", value);
        storageSet("certnz_timestamp", Date.now().toString());
      }
      manualLookup.addEventListener("input", updateManualLookup);
      updateManualLookup();
    }

    var panelAddress = document.getElementById("propAddress");
    if (panelAddress && !panelAddress.__certnzAddressPersistFixed) {
      panelAddress.__certnzAddressPersistFixed = true;
      new MutationObserver(remember).observe(panelAddress, { childList: true, subtree: true, characterData: true });
    }

    var titleRef = document.getElementById("titleRefValue");
    if (titleRef && !titleRef.__certnzTitlePersistFixed) {
      titleRef.__certnzTitlePersistFixed = true;
      new MutationObserver(remember).observe(titleRef, { childList: true, subtree: true, characterData: true });
    }
  }

  function patchHome() {
    patchAddressPersistence();
    patchProductButtons();

    document.querySelectorAll(".panel-card-buy").forEach(function (button) {
      var key = button.getAttribute("data-product");
      if (!PRODUCT_HANDLES[key]) return;
      button.setAttribute("title", "Add this document with the selected property details");
    });
  }

  ready(patchHome);
  window.addEventListener("load", patchHome);
  setTimeout(patchHome, 800);
  setTimeout(patchHome, 2000);
})();
